import React, {Component} from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Nav from '../components/Nav';
import '../styles/styles.css';

class About extends Component {
    render() {
        return(
            <div>
                <Header/>
                <Nav/>
                <div>
                    <h2>Paragraph Topic 1</h2>
                    <p>Lorem ipsum dolor sit amet. Non quia perferendis et consequuntur expedita vel consequuntur maxime qui animi atque non culpa obcaecati qui nihil animi sit accusantium maiores. Est provident odit qui dignissimos dolores ab corrupti iure sit doloribus dolores et galisum aspernatur est eaque voluptatem. Eaque accusamus aut maxime provident est saepe perspiciatis? Et totam perspiciatis aut dicta nulla aut sunt veniam est quas maiores a quam voluptate omnis dolores? Et voluptate sint et earum assumenda sed earum itaque. Est natus id laudantium quasi ea iusto quos est consectetur pariatur ea libero magnam ea adipisci iure. Et neque minima id inventore fugiat quo magni accusamus et perferendis quia. Ab dolores assumenda in veritatis perspiciatis quo voluptatibus sunt et voluptates tenetur qui iste consequatur qui sunt vero. Et repellat autem harum incidunt aut doloremque nihil ex sint saepe id autem odit.</p>
                </div>
                <Footer />
            </div>
        )
    }
}

export default About;